import React, { useState, useEffect } from 'react';
import { Form, Image, Button, Figure, ProgressBar } from 'react-bootstrap';
import styles from './index.module.scss';
import imagemVazia from './imagem.png';

// função
function Foto({
    imagem,
    onChange: alterouArquivo,
    progresso,
    arquivo,
    classeBotao='my-3',
    classeTexto='',
    classeFormulario=''
}){
    const [imagemTemporaria, alterarImagemTemporaria] = useState(imagemVazia);

    // referencias
    let inputRef = React.createRef();

    // inicializa
    useEffect(() => {        
        // nulo
        if(imagem !== null){
            alterarImagemTemporaria(`${process.env.REACT_APP_URL_ARQUIVOS}/arquivos/fotos/${imagem}`);
        }
    }, [imagem]);
    
    return (
        <Form.Group className={`${classeFormulario}`}>
            <Figure className={styles.containerImagem}>
                <Image 
                    src={imagemTemporaria} 
                    alt={'Imagem temporária'}
                    rounded 
                    fluid  
                />
                {progresso &&
                    <div className={styles.carregandoImagem}>
                        <ProgressBar className={styles.barra} animated now={progresso} label={`${progresso}%`} />
                    </div>
                }
            </Figure>
            
            <p className={`d-flex justify-content-center ${classeTexto}`}>
                <input 
                    hidden 
                    type="file" 
                    ref={inputRef} 
                    onChange={() => {
                        if(inputRef.current.files.length > 0){
                            // função para carregar imagem
                            let reader = new FileReader();

                            // ao carregar imagem
                            reader.onload = (e) => {
                                
                                alterouArquivo(inputRef.current.files[0]);
                                alterarImagemTemporaria(e.target.result);
                            };

                            // pega a imagem
                            reader.readAsDataURL(inputRef.current.files[0]);
                        }
                    }} 
                />
                <Button 
                    variant="padrao" 
                    className={`${classeBotao}`} 
                    onClick={() => {
                        inputRef.current.click();
                    }}
                >
                    Alterar
                </Button>
            </p>
        </Form.Group>
    )

}

export default Foto;